import { Box, styled } from '@mui/material'
import { SvgImage } from 'components/ui'
import { useEffect, useState } from 'react'
import { APIs } from 'services'
import { screenType, useWindowSize } from 'utils'

interface ICloudPay {
  account: string
  onClose: () => void
}

export const CloudPay = ({ account, onClose }: ICloudPay): JSX.Element => {
  const { width } = useWindowSize()
  const [visible, setVisible] = useState<boolean>(false)
  const [iframeUrl, setIframeUrl] = useState<string>('')

  useEffect(() => {
    const cloudPay = async (): Promise<void> => {
      try {
        const cloudData = await APIs.getCloudData({ accountNumber: account })
        if (cloudData.data?.Data?.CloudPaymentURL) {
          setIframeUrl(cloudData.data?.Data?.CloudPaymentURL)
          setVisible(true)
        }
      } catch (e) { }
    }

    cloudPay()
  }, [account])

  const handleHide = (): void => {
    setVisible(false)
    onClose()
  }

  return (
    <Box>
      <ICModal visible={visible ? 'true' : 'false'}>
        <ICModalContent ismobile={screenType(width, 'sm') ? 'true' : 'false'}>
          <CloseButton
            sx={{ margin: screenType(width, 'sm') ? '5px' : '0' }}
            onClick={handleHide}
          >
            <SvgImage name="CloseIcon" width={24} height={24} />
          </CloseButton>

          {screenType(width, 'sm')
            ? (
              <iframe
                frameBorder="0"
                src={iframeUrl}
                width="100%"
                allow="payment *"
                height="90%"
                title="Cloud Pay"
              />
            )
            : (
              <iframe
                frameBorder="0"
                src={iframeUrl}
                width="100%"
                allow="payment *"
                height="550"
                title="Cloud Pay"
              />
            )}
        </ICModalContent>
      </ICModal>
    </Box>
  )
}

export const ICModal = styled(Box)<{ visible: string }>(({ visible }) => ({
  position: 'fixed',
  left: 0,
  zIndex: 999,
  top: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  opacity: visible === 'true' ? 1 : 0,
  visibility: visible === 'true' ? 'visible' : 'hidden',
  transform: visible === 'true' ? 'schle(1)' : 'scale(1.1)',
  transition: 'visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s'
}))

export const ICModalContent = styled(Box)<{ ismobile: string }>(
  ({ ismobile }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    padding: ismobile === 'true' ? '0rem 0.5rem' : '1rem 1.5rem',
    width: ismobile === 'true' ? '100vw' : '45rem',
    borderRadius: ismobile === 'true' ? '0' : '0.5rem',
    height: ismobile === 'true' ? '100vh' : 'inherite'
  })
)

export const CloseButton = styled(Box)({
  float: 'right',
  width: '1.5rem',
  lineHeight: '1.5rem',
  textAlign: 'center',
  cursor: 'pointer',
  borderRadius: '0.25rem',
  backgroundColor: 'lightgray',
  margin: '5px',

  '&:hover': {
    backgroundColor: 'darkgray'
  }
})
